import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { FaCheckCircle, FaSpinner } from 'react-icons/fa';
import './Subscribe.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { currentUser } = useAuth();
  const [status, setStatus] = useState('verifying');

  useEffect(() => {
    const verifyPayment = async () => {
      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        setStatus('success');
        return;
      }

      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}/api/payment/success?session_id=${sessionId}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        const data = await response.json();
        
        if (data.success) {
          setStatus('success');
          toast.success('Subscription activated successfully!');
        } else {
          setStatus('error');
          toast.error('Payment verification failed');
        }
      } catch (error) {
        console.error('Verification error:', error);
        setStatus('error');
      }
    };

    if (currentUser) {
      verifyPayment();
    }
  }, [searchParams, currentUser]);

  const handleContinue = () => {
    navigate('/corporate-dashboard');
  };

  return (
    <div className="subscribe-page">
      <div className="subscribe-container">
        <div className="payment-section" style={{ textAlign: 'center', maxWidth: '500px' }}>
          {status === 'verifying' && (
            <>
              <FaSpinner className="spin-icon" style={{ fontSize: '48px', color: '#0B6623', marginBottom: '20px' }} />
              <h2>Verifying Payment...</h2>
              <p>Please wait while we confirm your subscription.</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <FaCheckCircle style={{ fontSize: '64px', color: '#27ae60', marginBottom: '20px' }} />
              <h2>Payment Successful!</h2>
              <p style={{ marginBottom: '30px' }}>
                Your corporate subscription is now active. You have full access to all premium features.
              </p>
              <button className="btn-subscribe" onClick={handleContinue}>
                Go to Corporate Dashboard
              </button>
            </>
          )}
          
          {status === 'error' && (
            <>
              <div style={{ fontSize: '64px', color: '#e74c3c', marginBottom: '20px' }}>!</div>
              <h2>Verification Issue</h2>
              <p style={{ marginBottom: '30px' }}>
                We couldn't verify your payment. Please contact support if you believe this is an error.
              </p>
              <button className="btn-subscribe" onClick={() => navigate('/subscribe')}>
                Try Again
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
